// Runtime config injected via runtime-env.js (generated at container startup)
// Falls back to process.env (CRA build-time values) for local development
const config = window.__RUNTIME_CONFIG__ || {};

export const API_URL = config.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
export const LOGO_URL = config.REACT_APP_LOGO_URL || process.env.REACT_APP_LOGO_URL;
export const HOVER_URL = config.REACT_APP_HOVER_LOGO_URL || process.env.REACT_APP_HOVER_LOGO_URL;
export const FAVICON_URL = config.REACT_APP_FAVICON_URL || process.env.REACT_APP_FAVICON_URL;
export const LOGO_WHITE_URL = config.REACT_APP_LOGO_WHITE_URL || process.env.REACT_APP_LOGO_WHITE_URL;
export const COPYRIGHT_NAME = config.REACT_APP_COPYRIGHT_NAME || process.env.REACT_APP_COPYRIGHT_NAME;
export const PRIVACY_URL = config.REACT_APP_PRIVACY_URL || process.env.REACT_APP_PRIVACY_URL;
export const CONTACT_URL = config.REACT_APP_CONTACT_URL || process.env.REACT_APP_CONTACT_URL;
export const COPYRIGHT_URL = config.REACT_APP_COPYRIGHT_URL || process.env.REACT_APP_COPYRIGHT_URL;

export const GRAPH_COLORS = {
	PRIMARY: config.REACT_APP_PRIMARY_COLOR || process.env.REACT_APP_PRIMARY_COLOR,
	GREEN: '#2eb85c',
	RED: '#e55353',
	YELLOW: '#f9b115',
	BLUE: '#4a90e2',
};

export const Roles = {
	0: 'Super Admin',
	1: 'Admin',
	2: 'MSSP Admin',
	3: 'End User',
	4: 'Read Only',
};

export const AllRights = [];

export const Rights = {
	//client related rights
	can_view_clients: [0, 1, 2],
	can_edit_clients: [0, 1, 2],

	//employees related rights
	can_view_employees: [1, 2, 3, 4],
	can_edit_employees: [1, 2, 3],

	//portal users related rights
	// MSSP admins (2) may view/manage users of the customers they own; the
	// customer-scoped Users pages and API already scope them to those customers.
	// The platform-level Users nav is kept staff-only separately (see _nav.js).
	can_view_users: [0, 1, 2],
	can_edit_users: [0, 1, 2],

	//org users related rights
	can_view_org_users: [0, 1, 2],
	can_edit_org_users: [0, 1, 2],

	//tempaltes related rights
	can_view_email_templates: [0, 1, 2, 3, 4],
	can_edit_email_templates: [0, 1, 2],
	can_view_sms_templates: [0, 1, 2, 3, 4],
	can_edit_sms_templates: [0, 1, 2],
	can_view_system_templates: [0, 1, 2, 3, 4],
	can_edit_system_templates: [0, 1, 2, 3],
	can_view_voice_templates: [0, 1, 2, 3, 4],
	can_edit_voice_templates: [0, 1, 2],

	//landing page related rights
	can_view_landing_pages: [0, 1, 2],
	can_edit_landing_pages: [0, 1, 2],

	//campaign related rights
	can_view_campaigns: [1, 2, 3, 4],
	can_create_campaigns: [1, 2, 3],
	can_edit_campaigns: [1, 2, 3],

	can_view_email_campaigns: [1, 2, 3, 4],
	can_edit_email_campaigns: [1, 2, 3],
	can_view_sms_campaigns: [1, 2, 3, 4],
	can_edit_sms_campaigns: [1, 2, 3],
	can_view_whatsapp_campaigns: [1, 2, 3, 4],
	can_edit_whatsapp_campaigns: [1, 2, 3],
	can_view_system_campaigns: [1, 2, 3, 4],
	can_edit_system_campaigns: [1, 2, 3],
	can_view_voice_campaigns: [1, 2, 3, 4],
	can_edit_voice_campaigns: [1, 2, 3],
	can_edit_training_campaigns: [1, 2, 3],

	can_edit_smtp_details: [1, 2, 3],

	can_view_phishing_reports: [1, 2, 3, 4],
	can_edit_phishing_reports: [1, 2, 3],

	can_customize_system_notifiers_template: [0,1,2,3],
	can_test_system_notifiers_template: [0,1,2,3],

	can_view_cyber_news_feeds: [0,1,2,3,4]
};

// export const Services = ['phishing', 'training', 'vishing', 'smishing', 'whatsapp'];
export const Services = ['phishing', 'training', 'vishing', 'smishing', 'whatsapp'];

export const ServiceRights = {
	phishing: ['can_view_email_campaigns', 'can_edit_email_campaigns'],
	training: ['can_view_training_campaigns', 'can_edit_training_campaigns'],
	reporter: ['can_view_phishing_reports', 'can_edit_phishing_reports'],
	// vishing: ['can_view_voice_campaigns', 'can_edit_voice_campaigns'],
	// smishing: ['can_view_sms_campaigns', 'can_edit_sms_campaigns'],
	// whatsapp: ['can_view_whatsapp_campaigns', 'can_edit_whatsapp_campaigns'],
};

export const SYSTEM_TEMPLATE_TYPES = [
	{ name: 'User Onboarding', value: 'user_onboarding' },
	{ name: 'Training Assignment', value: 'training_assignment' },
	{ name: 'Training Reminder', value: 'training_reminder' },
	{ name: 'Training Escalation', value: 'training_escalation' },
	{ name: 'Reset Password', value: 'reset_password' },
];

export const CampaignTypeServiceMap = {
	email: ['phishing'],
	sms: ['smishing'],
	whatsapp: ['whatsapp'],
	voice: ['vishing'],
	training: ['training'],
	email_training: ['phishing', 'training'],
	sms_training: ['smishing', 'training'], // Add this line
	attachment: ['phishing'],
	reporter: ['reporter'],
};

export const MICROSOFT_APP_ID = config.REACT_APP_MICROSOFT_APP_ID || process.env.REACT_APP_MICROSOFT_APP_ID;

export const MICROSOFT_READ_ALL_USER_SCOPE = 'openid+user.read.all+email+profile+user.read+offline_access';
export const MICROSOFT_READ_ALL_GROUPS_SCOPE = 'openid+group.read.all+email';
export const MICROSOFT_LOGIN_USER_SCOPE = 'openid+email+profile+user.read+offline_access';

export const ITEMS_PER_PAGE = [10, 20, 50, 100]

export const getRole = (accessLevel) => {
  switch (accessLevel) {
    case 0:
      return 'Super Admin';
    case 1:
      return 'Admin';
    case 2:
      return 'MSSP Admin';
    case 3:
      return 'End User';
    case 4:
      return 'Read Only';
    default:
      return 'Unknown';
  }
};

export const CampaignTypes = {
  EMAIL: 'email',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
  VOICE: 'voice',
  TRAINING: 'training',
  EMAIL_TRAINING: 'email_training',
  SMS_TRAINING: 'sms_training',
  ATTACHMENT: 'attachment',
};

export const REPEAT_OFFENDER_FIXED_CAMPAIGNS = 3;
export const REPEAT_OFFENDER_MIN_CAMPAIGNS = 2;
export const REPEAT_OFFENDER_MAX_CAMPAIGNS = 4;
export const REPEAT_OFFENDER_CAMPAIGNS_PAGE_SIZE = 10;
export const REPEAT_OFFENDER_OFFENDERS_PAGE_SIZE = 25;

export const REPEAT_OFFENDER_CAMPAIGN_TYPE_LABELS = {
	[CampaignTypes.EMAIL]: 'Email',
	[CampaignTypes.SMS]: 'SMS',
	[CampaignTypes.VOICE]: 'Voice',
	[CampaignTypes.WHATSAPP]: 'WhatsApp',
};
